/* global angular:false */

(function() {
    "use strict";

    angular.module("vendd")
        .controller('CheckoutShippingAddressController', function($scope, $q, $element, $http, ControlService, CommonUtils, Validation) {
            $scope.Model = $scope.Model || {};
            $scope.Control = $scope.Control || {};

            var controlName = 'ShippingAddress';
            $scope.registerControl(controlName, $element.get(0));

            $scope.Control.IsValid = true;
            $scope.Control.IsOpen = false;
            $scope.Control.Selected = 0;
            $scope.Control.Text = {};
            $scope.Control.Form = {};

            var changedFields = {};
            var fieldValues = {};

            var orScope = angular.element('.x-control.x-angular-control.x-checkoutorder').scope();

            var $prefectureField = $('.form-row.prefecture', $element);
            var $cityField = $('.form-row.city', $element);
            var $areaField = $('.form-row.area', $element);
            var $postCodeField = $('.form-row.postcode', $element);
            var $addressField = $('.form-row.address', $element);

            var prevValues = {
                PostCode: {
                    Country: null,
                    Prefecture: null,
                    City: null,
                    Area: null,
                    PostCode: null
                },
                Street: {
                    Country: null,
                    Prefecture: null,
                    City: null,
                    Area: null,
                    PostCode: null
                }
            };

            var firstLoadForPostCode = true;

            $scope.Control.Loading = false;
            $scope.Control.PostCodeFound = false;

            var validators = [];
            var initiallyValidated = false;

            var options = {
                callback: function (value) {
                    var fieldName = $(this).data("fieldname");
                    var validate = $(this).data("validate");

                    if (validate)
                        $scope.Control.validateField('Control.Form.' + fieldName);
                },
                wait: 750,
                highlight: false,
                allowSubmit: false,
                captureLength: 1
            };

            $element.find("input[type = text], input[type = tel]").typeWatch(options);

            var savedData = new SavedDataState();

            var setAddress = function(address, reload) {
                var deferred = $q.defer();

                ControlService.invokeCheckout($scope, $element, 'SetShippingAddress', address).then(function (setResponse) {

                    $scope.setControlValue(controlName, address);

                    var billingAsShipping = $scope.$parent.BillingAsShipping;

                    if (billingAsShipping && $scope.Config.IsShippingEnabled && $scope.Order.Current.DeliveryPoint.Code.indexOf("onSite") > -1) {
                        var billingAddressForm = $scope['BillingAddress'].Current;

                        var billingAddress = {};
                        _.extend(billingAddress, address);

                        if ((billingAddressForm || {}).IsInvoice) {
                            billingAddress.IsInvoice = true;
                            billingAddress.CompanyName = billingAddressForm.CompanyName;
                            billingAddress.Occupation = billingAddressForm.Occupation;
                            billingAddress.Headquarters = billingAddressForm.Headquarters;
                            billingAddress.TaxAgency = billingAddressForm.TaxAgency;
                            billingAddress.TaxIdentifier = billingAddressForm.TaxIdentifier;
                        }

                        var $baScope = angular.element($scope['BillingAddress'].Wrapper).scope();

                        if (checkoutOverrides && checkoutOverrides.Shipping && typeof checkoutOverrides.Shipping.ChangeBilling === 'function') {
                            billingAddress = checkoutOverrides.Shipping.ChangeBilling(orScope, $baScope, billingAddress);
                        }

                        $baScope.Control.setAddress(billingAddress, false);
                    }

                    if (reload) {
                        if ($scope['Order'] && $scope['Order'].Wrapper && typeof ($scope['Order'].Wrapper.reload) == 'function') {
                            $scope['Order'].Wrapper.reload().then(function (orderResponse) {
                                if ($scope.Config.IsExplicitTimeslotEnabled) {
                                    $('.x-control.x-angular-control.x-checkoutorderexplicittimeslot').get(0).reload();
                                }

                                if ($scope['ShippingMethod'] && $scope['ShippingMethod'].Wrapper && typeof ($scope['ShippingMethod'].Wrapper.reload) == 'function') {
                                    $scope['ShippingMethod'].Wrapper.reload().then(function(smresponse) {
                                        if ($scope['PaymentMethod'] && $scope['PaymentMethod'].Wrapper && typeof ($scope['PaymentMethod'].Wrapper.reload) == 'function') {
                                            $scope['PaymentMethod'].Wrapper.reload().then(function(bmresponse) {
                                                deferred.resolve();
                                                $scope.Control.Loading = false;
                                            }, function(bmerror) {
                                                deferred.reject(bmerror);
                                                $scope.Control.Loading = false;
                                            });
                                        } else {
                                            deferred.resolve();
                                            $scope.Control.Loading = false;
                                        }
                                    }, function(smerror) {
                                        deferred.reject(smerror);
                                        $scope.Control.Loading = false;
                                    });
                                } else {
                                    deferred.resolve();
                                    $scope.Control.Loading = false;
                                }
                            }, function(orderError) {
                                deferred.reject(orderError);
                                $scope.Control.Loading = false;
                            });
                        } else {
                            deferred.resolve();
                            $scope.Control.Loading = false;
                        }
                    } else {
                        $.extend($scope.Order.Current.Shipping, _.pick(address, _.filter(_.keys($scope.Order.Current.Shipping), function (x) { return x !== "GeoZones" })));

                        deferred.resolve();
                        $scope.Control.Loading = false;
                    }
                }, function(setError) {
                    deferred.reject(setError);
                    $scope.Control.Loading = false;
                });


                return deferred.promise;
            };

            var bindAreaAutoComplete = function() {
                var $postCode = $('input[type="text"][ng-model="Control.Form.PostCode"]', $element);
                var $area = $('input[type="text"][ng-model="Control.Form.Area"]', $element);
                var $city = $('input[type="text"][ng-model="Control.Form.City"]', $element);
                var $countries = $('select[ng-model="Control.Form.Country"]', $element);
                if ($postCode.length > 0 && $area.length > 0 && $city.length > 0 && $countries.length > 0) {

                    var formData = $scope.Control.Form;
                    if (!formData.Country) {
                    	if ($scope.Model.Data.Addresses.length > 0)
                    		formData = _.first(_.filter($scope.Model.Data.Addresses, function (x) { return x.Id == $scope.Control.Selected; }));
                    	else {
                    		formData.Country = "";
                    	}
                    }
                    var modelData = $scope.Model.Data;

                    bindPostalCodeLookup($countries, $postCode, $area, $city, modelData, formData, function (area, city, postCode, hasMultipleAreas) {
                        $scope.Locked = true;

                        $scope.Control.Form.PostCode = postCode;
                        $scope.Control.Form.Area = area;
                        $scope.Control.Form.City = city;

                        $scope.Control.PostCodeFound = postCode !== '' && (area !== '' || (area === '' && hasMultipleAreas));

                        if (initiallyValidated) {
                            $scope.Control.validateField('Control.Form.PostCode');
                            $scope.Control.validateField('Control.Form.Area');
                            $scope.Control.validateField('Control.Form.City');
                        } else {
                            if ($scope.Control.PostCodeFound) {
                                $scope.Control.Form.PostCodeInvalid = false;
                                $scope.Control.Form.PostCodeError = false;
                            } else {
                                $scope.Control.Form.PostCodeInvalid = true;
                                $scope.Control.Form.PostCodeError = true;
                            }
                        }

                        $scope.Control.Loading = false;
                        $scope.$apply();

                        var reload = $scope.Control.Form.PostCode && $scope.Control.Form.Area !== '' &&
                            (
                                ($scope.Control.Form.PostCode.length === 5 && $scope.Control.Form.Country === 'GR') ||
                                ($scope.Control.Form.PostCode.length === 4 && $scope.Control.Form.Country === 'CY') ||
                                ($scope.Control.Form.PostCode.length === 7 && $scope.Control.Form.Country === 'CL') ||
                                ($scope.Control.Form.PostCode.length === 4 && $scope.Control.Form.Country === 'HU')
                            );

                        applyChanges(reload).then(function (response) {
                            $scope.Control.Loading = false;
                            $scope.Locked = false;
                        }, function(error) {
                            $scope.Control.Loading = false;
                            $scope.Locked = false;
                            throw error;
                        });
                    }, function(area, postCode) {
                        if (!area || area === '') {
                            $scope.Control.Form.Area = '';
                            $scope.$apply();
                        }
                    });
                }
            };

            var setFormCountry = function() {
                var country = _.first(_.filter($scope.Model.Data.ShippingCountries, function(x) { return x.Code == $scope.Control.Form.Country; }));
                $scope.Control.Form.CountryName = country ? country.Name : '';
            };

            var setTextCountry = function() {
                var country = _.first(_.filter($scope.Model.Data.ShippingCountries, function(x) { return x.Code == $scope.Control.Text.Country; }));
                $scope.Control.Text.CountryName = country ? country.Name : '';
            };

            var applyChanges = function(reload) {
                var deferred = $q.defer();
                setAddress(CommonUtils.clone($scope.Control.Form), reload).then(function(response) {
                    deferred.resolve(response);
                }, function(error) {
                    deferred.reject(error);
                });
                return deferred.promise;
            };

            $scope.Control.resetAutofillInputs = function () {
                if ($scope.Model.Data.Config.IsPostCodeAutofill) {
                    $scope.Control.Form.PostCode = "";
                }
                if ($scope.Model.Data.Config.IsAddressLine1Autofill) {
                    $scope.Control.Form.Address = "";
                }
            };

            $scope.Control.getServiceData = function (element, isChanged) {
                if (element === 'country') {
                    $scope.Control.resetAutofillInputs();
                    if ($scope.Model.Data.Config.IsPrefectureVisible && $scope.Model.Data.Config.IsPrefectureAutofill) {
                        $scope.Control.getPrefectures(isChanged);
                    } else if ($scope.Model.Data.Config.IsCityVisible && $scope.Model.Data.Config.IsCityAutofill) {
                        $scope.Control.getCities(isChanged);
                    } else if ($scope.Model.Data.Config.IsAreaVisible && $scope.Model.Data.Config.IsAreaAutofill) {
                        $scope.Control.getAreas(isChanged);
                    }
                }

                if (element === 'prefecture') {
                    $scope.Control.resetAutofillInputs();
                    if ($scope.Model.Data.Config.IsCityVisible && $scope.Model.Data.Config.IsCityAutofill) {
                        $scope.Control.getCities(isChanged);
                    } else if ($scope.Model.Data.Config.IsAreaVisible && $scope.Model.Data.Config.IsAreaAutofill) {
                        $scope.Control.getAreas(isChanged);
                    }
                }

                if (element === 'city') {                    
                    $scope.Control.resetAutofillInputs();
                    if ($scope.Model.Data.Config.IsAreaVisible && $scope.Model.Data.Config.IsAreaAutofill) {
                        $scope.Control.getAreas(isChanged);
                    }
                }

                if (element === 'area') {
                    $scope.Control.resetAutofillInputs();
                }
            };

            $scope.Control.getPrefectures = function (isChanged) {
                if ($scope.Model.Data.Config.IsPrefectureAutofill) {
                    if ($scope.Control.Form.Country) {
                        $prefectureField.addClass('x-loading');

                        $http({
                            async: true,
                            method: "POST",
                            contentType: 'application/json; charset=UTF-8',
                            ContentType: 'application/json; charset=UTF-8',
                            url: document.location.protocol.toLowerCase() + '//' + document.location.host.toLowerCase() + '/services/api/Address/GetAddressInfo',
                            data: {
                                fields: 'prefecture',
                                countryCode: $scope.Control.Form.Country
                            }
                        }).then(function mySuccess(response) {
                            $scope.Model.Data.Prefectures = _.map(response.data.data, function (obj) { return obj.prefecture; });

                            if ($scope.Model.Data.Prefectures.length < 1 || isChanged) {
                                $scope.Control.Form.Prefecture = "";
                                $scope.Control.Form.City = "";
                                $scope.Control.Form.Area = "";
                                $scope.Model.Data.Cities = [];
                                $scope.Model.Data.Areas = [];
                            }

                            $scope.Control.applyChanges();

                            if (checkoutConfig.hasSearch.prefectureSearch) $scope.Control.Search($prefectureField);
                            if (checkoutConfig.hasSearch.citySearch) $scope.Control.Search($cityField);
                            if (checkoutConfig.hasSearch.areaSearch) $scope.Control.Search($areaField);
                            $prefectureField.removeClass('x-loading');
                        }, function myError(response) {
                            $prefectureField.removeClass('x-loading');
                        });
                    } else {
                        $scope.Control.Form.Prefecture = "";
                        $scope.Control.Form.City = "";
                        $scope.Control.Form.Area = "";
                        $scope.Model.Data.Cities = [];
                        $scope.Model.Data.Areas = [];

                        $scope.Control.applyChanges();

                        if (checkoutConfig.hasSearch.prefectureSearch) $scope.Control.Search($prefectureField);
                        if (checkoutConfig.hasSearch.citySearch) $scope.Control.Search($cityField);
                        if (checkoutConfig.hasSearch.areaSearch) $scope.Control.Search($areaField);
                    }
                }
            };

            $scope.Control.getCities = function (isChanged) {
                if ($scope.Model.Data.Config.IsCityAutofill) {

                    if (typeof $scope.Control.Form.Prefecture === 'undefined') $scope.Control.Form.Prefecture = "";

                    var run = false;

                    if ($scope.Model.Data.Config.IsPrefectureAutofill && $scope.Model.Data.Config.IsPrefectureVisible) {
                        if ($scope.Control.Form.Country && $scope.Control.Form.Prefecture) {
                            run = true;
                        }
                    } else {
                        if ($scope.Control.Form.Country) {
                            run = true;
                        }
                    }

                    if (run) {
                        $cityField.addClass('x-loading');

                        $http({
                            async: true,
                            method: "POST",
                            contentType: 'application/json; charset=UTF-8',
                            ContentType: 'application/json; charset=UTF-8',
                            url: document.location.protocol.toLowerCase() + '//' + document.location.host.toLowerCase() + '/services/api/Address/GetAddressInfo',
                            data: {
                                fields: 'city',
                                countryCode: $scope.Control.Form.Country,
                                prefecture: $scope.Control.Form.Prefecture
                            }
                        }).then(function mySuccess(response) {
                            $scope.Model.Data.Cities = _.map(response.data.data, function (obj) { return obj.city; });

                            if ($scope.Model.Data.Cities.length < 1 || isChanged) {
                                $scope.Control.Form.City = "";
                                $scope.Control.Form.Area = "";
                                $scope.Model.Data.Areas = [];
                            }

                            $scope.Control.applyChanges();

                            if (checkoutConfig.hasSearch.citySearch) $scope.Control.Search($cityField);
                            if (checkoutConfig.hasSearch.areaSearch) $scope.Control.Search($areaField);
                            $cityField.removeClass('x-loading');
                        }, function myError(response) {
                            $cityField.removeClass('x-loading');
                        });
                    } else {
                        $scope.Control.Form.City = "";
                        $scope.Control.Form.Area = "";
                        $scope.Model.Data.Areas = [];

                        $scope.Control.applyChanges();

                        if (checkoutConfig.hasSearch.citySearch) $scope.Control.Search($cityField);
                        if (checkoutConfig.hasSearch.areaSearch) $scope.Control.Search($areaField);
                    }
                }
            };

            $scope.Control.getAreas = function (isChanged) {
                if ($scope.Model.Data.Config.IsAreaAutofill) {

                    if (typeof $scope.Control.Form.Prefecture === 'undefined') $scope.Control.Form.Prefecture = "";
                    if (typeof $scope.Control.Form.City === 'undefined') $scope.Control.Form.City = "";

                    var run = false;

                    if ($scope.Control.Form.Country) {
                        if ($scope.Model.Data.Config.IsPrefectureAutofill && $scope.Model.Data.Config.IsPrefectureVisible) {
                            if ($scope.Control.Form.Prefecture) {
                                if ($scope.Model.Data.Config.IsCityAutofill && $scope.Model.Data.Config.IsCityVisible) {
                                    if ($scope.Control.Form.City) {
                                        run = true;
                                    }
                                } else {
                                    run = true;
                                }
                            }
                        } else if ($scope.Model.Data.Config.IsCityAutofill && $scope.Model.Data.Config.IsCityVisible) {
                            if ($scope.Control.Form.City) {
                                run = true;
                            }
                        } else {
                            run = true;
                        }
                    }

                    if (run) {
                        $areaField.addClass('x-loading');

                        $http({
                            async: true,
                            method: "POST",
                            contentType: 'application/json; charset=UTF-8',
                            ContentType: 'application/json; charset=UTF-8',
                            url: document.location.protocol.toLowerCase() + '//' + document.location.host.toLowerCase() + '/services/api/Address/GetAddressInfo',
                            data: {
                                fields: 'geoArea',
                                countryCode: $scope.Control.Form.Country,
                                prefecture: $scope.Control.Form.Prefecture,
                                city: $scope.Control.Form.City
                            }
                        }).then(function mySuccess(response) {
                            $scope.Model.Data.Areas = _.map(response.data.data, function (obj) { return obj.geoArea; });

                            if ($scope.Model.Data.Areas.length < 1 || isChanged) {
                                $scope.Control.Form.Area = "";
                            }

                            $scope.Control.applyChanges();

                            if (checkoutConfig.hasSearch.areaSearch) $scope.Control.Search($areaField);
                            $areaField.removeClass('x-loading');
                        }, function myError(response) {
                            $areaField.removeClass('x-loading');
                        });
                    } else {
                        $scope.Control.Form.Area = "";

                        $scope.Control.applyChanges();

                        if (checkoutConfig.hasSearch.areaSearch) $scope.Control.Search($areaField);
                    }
                }
            };

            $scope.Control.getPostCodes = function (isChanged) {
                if ($scope.Model.Data.Config.IsPostCodeAutofill) {

                    if (typeof $scope.Control.Form.Prefecture === 'undefined') $scope.Control.Form.Prefecture = "";
                    if (typeof $scope.Control.Form.City === 'undefined') $scope.Control.Form.City = "";
                    if (typeof $scope.Control.Form.Area === 'undefined') $scope.Control.Form.Area = "";

                    var run = false;

                    if ($scope.Control.Form.Country) {
                        if ($scope.Model.Data.Config.IsPrefectureAutofill && $scope.Model.Data.Config.IsPrefectureVisible) {
                            if ($scope.Control.Form.Prefecture) {
                                if ($scope.Model.Data.Config.IsCityAutofill && $scope.Model.Data.Config.IsCityVisible) {
                                    if ($scope.Control.Form.City) {
                                        if ($scope.Model.Data.Config.IsAreaAutofill && $scope.Model.Data.Config.IsAreaVisible) {
                                            if ($scope.Control.Form.Area) {
                                                run = true;
                                            }
                                        } else {
                                            run = true;
                                        }
                                    }
                                } else {
                                    run = true;
                                }
                            }
                        } else if ($scope.Model.Data.Config.IsCityAutofill && $scope.Model.Data.Config.IsCityVisible) {
                            if ($scope.Control.Form.City) {
                                if ($scope.Model.Data.Config.IsAreaAutofill && $scope.Model.Data.Config.IsAreaVisible) {
                                    if ($scope.Control.Form.Area) {
                                        run = true;
                                    }
                                } else {
                                    run = true;
                                }
                            }
                        } else if ($scope.Model.Data.Config.IsAreaAutofill && $scope.Model.Data.Config.IsAreaVisible) {
                            if ($scope.Control.Form.Area) {
                                run = true;
                            }
                        } else {
                            run = true;
                        }
                    }

                    if (run) {
                        if (prevValues.PostCode.Country != $scope.Control.Form.Country || prevValues.PostCode.Prefecture != $scope.Control.Form.Prefecture || prevValues.PostCode.City != $scope.Control.Form.City || prevValues.PostCode.Area != $scope.Control.Form.Area || prevValues.PostCode.PostCode != $scope.Control.Form.PostCode) {
                            prevValues.PostCode.Country = $scope.Control.Form.Country;
                            prevValues.PostCode.Prefecture = $scope.Control.Form.Prefecture;
                            prevValues.PostCode.City = $scope.Control.Form.City;
                            prevValues.PostCode.Area = $scope.Control.Form.Area;
                            prevValues.PostCode.PostCode = $scope.Control.Form.PostCode;

                            $postCodeField.addClass('x-loading');

                            $http({
                                async: true,
                                method: "POST",
                                contentType: 'application/json; charset=UTF-8',
                                ContentType: 'application/json; charset=UTF-8',
                                url: document.location.protocol.toLowerCase() + '//' + document.location.host.toLowerCase() + '/services/api/Address/GetAddressInfo',
                                data: {
                                    fields: 'postalCode',
                                    countryCode: $scope.Control.Form.Country,
                                    prefecture: $scope.Control.Form.Prefecture,
                                    city: $scope.Control.Form.City,
                                    postalCode: '*' + $scope.Control.Form.PostCode + '*'
                                }
                            }).then(function mySuccess(response) {
                                $scope.Model.Data.PostCodes = _.map(response.data.data, function (obj) { return obj.postalCode; });

                                $scope.Control.showPostCodes = true;                            
                                $postCodeField.removeClass('x-loading');
                                $('.autofill-input', $postCodeField).focus();                            
                            }, function myError(response) {
                                $postCodeField.removeClass('x-loading');
                            });
                        } else {
                            $scope.Control.showPostCodes = true;
                        }
                    }
                }
            };

            $scope.Control.getStreets = function (isChanged) {
                if ($scope.Model.Data.Config.IsAddressLine1Autofill) {

                    if (typeof $scope.Control.Form.Prefecture === 'undefined') $scope.Control.Form.Prefecture = "";
                    if (typeof $scope.Control.Form.City === 'undefined') $scope.Control.Form.City = "";
                    if (typeof $scope.Control.Form.Area === 'undefined') $scope.Control.Form.Area = "";

                    var run = false;

                    if ($scope.Control.Form.Country) {
                        if ($scope.Model.Data.Config.IsPrefectureAutofill && $scope.Model.Data.Config.IsPrefectureVisible) {
                            if ($scope.Control.Form.Prefecture) {
                                if ($scope.Model.Data.Config.IsCityAutofill && $scope.Model.Data.Config.IsCityVisible) {
                                    if ($scope.Control.Form.City) {
                                        if ($scope.Model.Data.Config.IsAreaAutofill && $scope.Model.Data.Config.IsAreaVisible) {
                                            if ($scope.Control.Form.Area) {
                                                run = true;
                                            }
                                        } else {
                                            run = true;
                                        }
                                    }
                                } else {
                                    run = true;
                                }
                            }
                        } else if ($scope.Model.Data.Config.IsCityAutofill && $scope.Model.Data.Config.IsCityVisible) {
                            if ($scope.Control.Form.City) {
                                if ($scope.Model.Data.Config.IsAreaAutofill && $scope.Model.Data.Config.IsAreaVisible) {
                                    if ($scope.Control.Form.Area) {
                                        run = true;
                                    }
                                } else {
                                    run = true;
                                }
                            }
                        } else if ($scope.Model.Data.Config.IsAreaAutofill && $scope.Model.Data.Config.IsAreaVisible) {
                            if ($scope.Control.Form.Area) {
                                run = true;
                            }
                        } else {
                            run = true;
                        }
                    }

                    if (run) {
                        if (prevValues.Street.Country != $scope.Control.Form.Country || prevValues.Street.Prefecture != $scope.Control.Form.Prefecture || prevValues.Street.City != $scope.Control.Form.City || prevValues.Street.Area != $scope.Control.Form.Area || prevValues.Street.Address != $scope.Control.Form.Address) {
                            prevValues.Street.Country = $scope.Control.Form.Country;
                            prevValues.Street.Prefecture = $scope.Control.Form.Prefecture;
                            prevValues.Street.City = $scope.Control.Form.City;
                            prevValues.Street.Area = $scope.Control.Form.Area;
                            prevValues.Street.Address = $scope.Control.Form.Address;

                            $addressField.addClass('x-loading');

                            $http({
                                async: true,
                                method: "POST",
                                contentType: 'application/json; charset=UTF-8',
                                ContentType: 'application/json; charset=UTF-8',
                                url: document.location.protocol.toLowerCase() + '//' + document.location.host.toLowerCase() + '/services/api/Address/GetAddressInfo',
                                data: {
                                    fields: 'street',
                                    countryCode: $scope.Control.Form.Country,
                                    prefecture: $scope.Control.Form.Prefecture,
                                    city: $scope.Control.Form.City,
                                    postalCode: '',
                                    street: '*' + $scope.Control.Form.Address + '*'
                                }
                            }).then(function mySuccess(response) {
                                $scope.Model.Data.Streets = _.map(response.data.data, function (obj) { return obj.street; });

                                $scope.Control.showStreets = true;
                                $addressField.removeClass('x-loading');
                                $('.autofill-input', $addressField).focus(); 
                            }, function myError(response) {
                                $addressField.removeClass('x-loading');
                            });
                        } else {
                            $scope.Control.showStreets = true;
                        }
                    }
                }
            };

            $scope.Control.Search = function (el) {

                var $el = $(el);

                if ($('.chosen-container', $el).length > 0) {
                    if (checkoutOverrides && checkoutOverrides.Generic && typeof checkoutOverrides.Generic.UpdateChosenSearch === 'function') {
                        angular.element($el).ready(function () {
                            checkoutOverrides.Generic.UpdateChosenSearch($el);
                        });
                    }
                } else {
                    if (checkoutOverrides && checkoutOverrides.Generic && typeof checkoutOverrides.Generic.InitChosenSearch === 'function') {
                        angular.element($el).ready(function () {
                            checkoutOverrides.Generic.InitChosenSearch($el);
                        });
                    }
                }
            }

            $scope.Control.getCountryName = function (code) {
                var country = _.first(_.filter($scope.Model.Data.Countries, function (x) { return x.Code === code; }));
                return country ? country.Name : country;
            };

            $scope.Control.isCountryDisabled = function (code) {
                var country = _.first(_.filter($scope.Model.Data.ShippingCountries, function (x) { return x.Code === code; }));
                return country === undefined ? true : false;
            };

            $scope.Control.isAddressDisabled = function (address) {
                return $scope.Control.isCountryDisabled(address.Country);
            };

            $scope.Control.isAddressGroupDisabled = function (addressGroup) {
                return _.all(addressGroup.Items, $scope.Control.isAddressDisabled);
            };

            $scope.Control.controlFocused = function (name, value) {
                fieldValues[name] = value;
            };

            $scope.Control.controlBlured = function (name, value) {
                var prevValue = fieldValues[name];
                if (value !== prevValue)
                    changedFields[name] = true;
            };

            var profileForm = $('.x-checkoutprofile').scope().Control.Form;

            $scope.$watch('Profile.Current.FirstName', function (newValue, prevValue) {
                scopeWatchFirstName(newValue, prevValue);
            });

            var scopeWatchFirstName = function (newValue, prevValue) {
                if (($scope.Order.Current && !$scope.Order.Current.IsLoggedIn && $scope.Control.IsOpen) || checkoutConfig.watchParams.shipping.firstName) {
                    if (!changedFields['Control.Form.FirstName']) {
                        if ($scope.Control.Form.FirstName !== newValue && newValue !== "") {
                            $scope.Control.Form.FirstName = newValue;
                            setTimeout(function () {
                                $scope.Control.validateField('Control.Form.FirstName');
                            }, 750);
                        }
                    }
                }
            };
            scopeWatchFirstName(profileForm.FirstName, null);

            $scope.$watch('Profile.Current.LastName', function (newValue, prevValue) {
                scopeWatchLastName(newValue, prevValue);
            });
            var scopeWatchLastName = function (newValue, prevValue) {
                if (($scope.Order.Current && !$scope.Order.Current.IsLoggedIn && $scope.Control.IsOpen) || checkoutConfig.watchParams.shipping.lastName) {
                    if (!changedFields['Control.Form.LastName']) {
                        if ($scope.Control.Form.LastName !== newValue && newValue !== "") {
                            $scope.Control.Form.LastName = newValue;
                            setTimeout(function () {
                                $scope.Control.validateField('Control.Form.LastName');
                            }, 750);
                        }
                    }
                }
            }
            scopeWatchLastName(profileForm.LastName, null);

            $scope.$watch('Profile.Current.Email', function (newValue, prevValue) {
                scopeWatchEmail(newValue, prevValue);
            });
            var scopeWatchEmail = function (newValue, prevValue) {
                if (($scope.Order.Current && !$scope.Order.Current.IsLoggedIn && $scope.Control.IsOpen) || checkoutConfig.watchParams.shipping.email) {
                    if (!changedFields['Control.Form.Email']) {
                        if ($scope.Control.Form.Email !== newValue && newValue !== "") {
                            $scope.Control.Form.Email = newValue;
                            setTimeout(function () {
                                $scope.Control.validateField('Control.Form.Email');
                            }, 750);
                        }
                    }
                }
            };
            scopeWatchEmail(profileForm.Email, null);

            $scope.$watch('Profile.Current.Phone', function (newValue, prevValue) {
                scopeWatchPhone(newValue, prevValue);
            });
            var scopeWatchPhone = function (newValue, prevValue) {
                if (($scope.Order.Current && !$scope.Order.Current.IsLoggedIn && $scope.Control.IsOpen) || checkoutConfig.watchParams.shipping.phone) {
                    if (!changedFields['Control.Form.Phone']) {
                        if ($scope.Control.Form.Phone !== newValue && newValue !== "") {
                            $scope.Control.Form.Phone = newValue;
                            setTimeout(function(){
                                $scope.Control.validateField('Control.Form.Phone');
                            }, 750);
                        }
                    }
                }
            };
            scopeWatchPhone(profileForm.Phone, null);

            $scope.$watch('Profile.Current.Mobile', function (newValue, prevValue) {
                scopeWatchMobile(newValue, prevValue);
            });
            var scopeWatchMobile = function (newValue, prevValue) {
                if (($scope.Order.Current && !$scope.Order.Current.IsLoggedIn && $scope.Control.IsOpen) || checkoutConfig.watchParams.shipping.mobile) {
                    if (!changedFields['Control.Form.Mobile']) {
                        if ($scope.Control.Form.Mobile !== newValue && newValue !== "") {
                            $scope.Control.Form.Mobile = newValue;
                            setTimeout(function () {
                                $scope.Control.validateField('Control.Form.Mobile');
                            }, 750);
                        }
                    }
                }
            };
            scopeWatchMobile(profileForm.Mobile, null);

            $scope.Control.stored = function () {
                $scope.Control.Form = {};
                $scope.Control.SelectedError = false;

                $scope.Control.PostCodeFound = true;
                var selectedAddress = _.first(_.filter($scope.Model.Data.Addresses, function (x) { return x.IsDefault; }));
                if (selectedAddress === undefined)
                    selectedAddress = _.first($scope.Model.Data.Addresses);

                $scope.Control.Selected = selectedAddress.Id;
                $scope.Control.setAddress();
            };

            $scope.$on('newShipping', function () {
                $scope.Control.new();
                $scope.Control.IsOpen = true;
            });

            $scope.$on('setSelectedShipping', function () {
                $scope.Control.Selected = $scope.SelectedId;
                $scope.Control.setAddress();
            });

            $scope.Control.new = function() {
                $scope.Control.Form = {};

                if ($scope['Order'] && $scope['Order'].Current && $scope['Order'].Current.Shipping && $scope['Order'].Current.Shipping.Country) {
                    $scope.Control.Form.Country = $scope['Order'].Current.Shipping.Country;
                }

                $scope.Control.SelectedError = false;

                $scope.Control.PostCodeFound = true;

                $scope.Control.Loading = false;
                setAddress($scope.Control.Form).then(function(response) {
                    $scope.Control.Loading = false;
                    $scope.Control.Selected = 0;
                    $scope.Control.IsOpen = true;

                    if (orScope.Config.IsLazyloadAvailabilitiesEnabled) {
                        //reset model
                        var deliveryAvailabilities = _.each($scope.Order.Current.Products, function (item) { item.Availability = ''; });
                        var orderDeliveryAvailability = { HasOrderAvailability: false, OrderAvailabilityMessage: '' };

                        angular.extend($scope.Order.Current.Products, deliveryAvailabilities);
                        angular.extend($scope.Order.Current, orderDeliveryAvailability);
                    }

                }, function(error) {
                    $scope.Control.Loading = false;
                    throw error;
                });
            };

            $scope.Control.edit = function() {
                $scope.Control.Form = {};
                $scope.Control.SelectedError = false;

                $scope.Control.PostCodeFound = true;

                var selectedAddress = _.first(_.filter($scope.Model.Data.Addresses, function(x) { return x.Id == $scope.Control.Selected; }));

                if (selectedAddress) {
                    $scope.Control.Loading = false;
                    angular.extend($scope.Control.Form, selectedAddress);
                    $scope.Control.IsOpen = true;

                    var selectedTitle = _.first(_.filter($scope.Model.Data.Titles, function(x) { return x.Name === $scope.Control.Form.Title; }));
                    if (!selectedTitle)
                        $scope.Control.Form.Title = '';

                    var clonedAddress = CommonUtils.clone($scope.Control.Form);

                    $scope.Control.Loading = false;
                    setAddress(clonedAddress).then(function(response) {
                        $scope.Control.Loading = false;
                    }, function(error) {
                        $scope.Control.Loading = false;
                        throw error;
                    });

                    //reset Autofill
                    $scope.Control.getPrefectures();
                    $scope.Control.getCities();
                    $scope.Control.getAreas();
                }
            };

            $scope.Control.setAddress = function() {

                $scope.Control.Text = {};
                $scope.Control.IsOpen = false;

                var selectedAddress = _.first(_.filter($scope.Model.Data.Addresses, function(x) { return x.Id == $scope.Control.Selected; }));

                if (!$scope.Control.IsOpen) {
                    var selectedCountry = selectedAddress ? _.first(_.filter($scope.Model.Data.ShippingCountries, function (c) { return selectedAddress.Country == c.Code; })) : null;
                    $scope.Control.IsOpen = selectedAddress === undefined || (selectedAddress.PostCode != "" && selectedAddress.Area == "" && (selectedCountry ? selectedCountry.AreasCount > 1 : false));
                }

                if (selectedAddress !== undefined && !isAddressOk(selectedAddress))
                    $scope.Control.IsOpen = true;

                $scope.Control.Loading = false;

                angular.extend($scope.Control.Form, selectedAddress || {});
                if (!$scope.Control.IsOpen)
                    angular.extend($scope.Control.Text, selectedAddress || {});

                setAddress(CommonUtils.clone(selectedAddress), true).then(function (response) {
                    var selectedCountry = selectedAddress ? _.first(_.filter($scope.Model.Data.ShippingCountries, function (c) { return selectedAddress.Country == c.Code; })) : null;
                    if (selectedAddress !== undefined && selectedAddress.PostCode != "" && selectedAddress.Area == "" && (selectedCountry ? selectedCountry.AreasCount > 1 : false)) {
                        $('input[type="text"][ng-model="Control.Form.Area"]', $element).val("");
                        $('input', $postCodeField).trigger('keyup');
                    } else {
                        $('.postal-code-areas', $element).hide();
                    }

                    if (selectedAddress !== undefined && !isAddressOk(selectedAddress)) {
                        $scope.Control.getPrefectures();
                        $scope.Control.getCities();
                        $scope.Control.getAreas();
                    }

                    $scope.Control.Loading = false;
                }, function(error) {
                    $scope.Control.Loading = false;
                    throw error;
                });

                $scope.Control.SelectedError = false;
            };

            $scope.Control.validateField = function(name) {
                if (initiallyValidated) {
                    _.first(_.filter(validators, function(x) { return x.name == name; })).fn();
                }
            };

            $scope.Control.applyChanges = function (name) {
                var selectedCountry = _.first(_.filter($scope.Model.Data.ShippingCountries, function (c) { return $scope.Control.Form.Country == c.Code; }));

                if (!savedData.hasChanged($scope.Control.Form) || ($element.data('areaautocomplete') && selectedCountry && selectedCountry.AreasCount > 0 && name == 'postcode'))
                    return;

                $scope.Control.Loading = false;
                setFormCountry();
                if (name === 'postcode') {
                    $postCodeField.addClass('x-loading');
                }
                applyChanges(['country', 'postcode'].indexOf(name) !== -1).then(function(response) {
                    savedData.setData($scope.Control.Form);
                    $scope.Control.Loading = false;
                }, function(error) {
                    $scope.Control.Loading = false;
                    throw error;
                });

            };

            var suppressPostCodeInputFocusedChange = false, suppressStreetInputFocusedChange = false;

            $scope.Control.bindPostCode = function (postCode) {
                $scope.Control.Form.PostCode = postCode;
                $scope.Control.showPostCodes = false;
                $scope.Control.applyChanges();
            };

            $scope.Control.hidePostCodeList = function () {
                if (suppressPostCodeInputFocusedChange === true) {
                    suppressPostCodeInputFocusedChange = false;
                    return false;
                }
                $scope.Control.showPostCodes = false;
            };

            $scope.Control.suppressPostCodeInputFocus = function () {
                suppressPostCodeInputFocusedChange = true;
            };

            $scope.Control.bindStreet = function (street) {
                $scope.Control.Form.Address = street;
                $scope.Control.showStreets = false;
                $scope.Control.applyChanges();
            };

            $scope.Control.hideStreetList = function () {
                if (suppressStreetInputFocusedChange === true) {
                    suppressStreetInputFocusedChange = false;
                    return false;
                }
                $scope.Control.showStreets = false;
            };

            $scope.Control.suppressStreetInputFocus = function () {
                suppressStreetInputFocusedChange = true;
            };

            //watch for Lazyload Availabilities
            if (orScope.Config.IsLazyloadAvailabilitiesEnabled) {
                $scope.$watch('Control.Form.PostCode', function (newPostCode, prevPostCode) {
                    if (typeof newPostCode !== undefined && newPostCode && newPostCode.length == 5 && $scope.Order.Current.DeliveryPoint.Code.indexOf("onSite") > -1) {
                        if (firstLoadForPostCode) {
                            //call service and extend order model
                            orScope.bindDeliveryAvailabilities(newPostCode);
                        }
                    } else {
                        if (!firstLoadForPostCode) {
                            //reset model
                            orScope.resetDeliveryAvailabilities();
                        }
                    }
                    firstLoadForPostCode = false;
                });
            }

            validators.push({
                name: 'Control.Form.Title',
                fn: function() {
                    Validation.reset($scope, 'Control.Form.Title');
                    if ($scope.Model.Data.Config.IsTitleVisible && $scope.Model.Data.Config.IsTitleRequired) {
                        Validation.require($scope, 'Control.Form.Title').then(function(response) {}, function(error) {});
                    }
                }
            });

            validators.push({
                name: 'Control.Form.FirstName',
                fn: function() {
                    Validation.reset($scope, 'Control.Form.FirstName');
                    if ($scope.Model.Data.Config.IsFirstNameVisible && $scope.Model.Data.Config.IsFirstNameRequired) {
                        Validation.require($scope, 'Control.Form.FirstName').then(function(response) {}, function(error) {});
                    }
                }
            });

            validators.push({
                name: 'Control.Form.LastName',
                fn: function() {
                    Validation.reset($scope, 'Control.Form.LastName');
                    if ($scope.Model.Data.Config.IsLastNameVisible && $scope.Model.Data.Config.IsLastNameRequired) {
                        Validation.require($scope, 'Control.Form.LastName').then(function(response) {}, function(error) {});
                    }
                }
            });

            validators.push({
                name: 'Control.Form.Email',
                fn: function() {
                    Validation.reset($scope, 'Control.Form.Email');
                    if ($scope.Model.Data.Config.IsEmailVisible && $scope.Model.Data.Config.IsEmailRequired) {
                        Validation.require($scope, 'Control.Form.Email').then(function(response) {
                            Validation.isEmail($scope, 'Control.Form.Email').then(function(response) {
                            }, function(error) {});
                        }, function(error) {});
                    }
                }
            });

            validators.push({
                name: 'Control.Form.EmailConfirmation',
                fn: function() {
                    Validation.reset($scope, 'Control.Form.EmailConfirmation');
                    if ($scope.Model.Data.Config.IsEmailConfirmationVisible && $scope.Model.Data.Config.IsEmailConfirmationRequired) {
                        Validation.require($scope, 'Control.Form.EmailConfirmation').then(function(response) {
                            Validation.isSame($scope, 'Control.Form.EmailConfirmation', 'Control.Form.Email', {
                                suffix: 'Mismatch'
                            }).then(function(response) {
                            }, function(error) {});
                        }, function(error) {});
                    }
                    else if ($scope.Model.Data.Config.IsEmailConfirmationVisible) {
                        Validation.isSame($scope, 'Control.Form.EmailConfirmation', 'Control.Form.Email', {
                            suffix: 'Mismatch'
                        }).then(function (response) {
                        }, function (error) { });

                    }
                }
            });

            validators.push({
                name: 'Control.Form.Phone',
                fn: function() {
                    Validation.reset($scope, 'Control.Form.Phone');
                    if ($scope.Model.Data.Config.IsPhoneVisible) {
                        if ($scope.Model.Data.Config.IsPhoneRequired) {
                            Validation.require($scope, 'Control.Form.Phone').then(function (response) {
                                if (checkoutConfig.phoneLocalizationEnabled) {
                                    var $inputPhone = $('.form-row.phone.js-phone-localization input', $element);
                                    Validation.isValidPhoneLocalized($scope, 'Control.Form.Phone', $inputPhone, $inputPhone.data('localized-validation'), {

                                    }).then(function (response) {
                                    }, function (error) {
                                        $scope.Control.IsOpen = true;
                                    });
                                } else if ($scope.Control.Form.Country === 'GR' && checkoutConfig.greekPhoneValidation) {
                                    $scope.Model.Data.Config.IsGreekPhone = true;
                                    Validation.isMatch($scope, 'Control.Form.Phone', /^2[0-9]{9}$/g, {

                                    }).then(function (response) {
                                    }, function (error) {
                                        $scope.Control.IsOpen = true;
                                    });
                                } else {
                                    $scope.Model.Data.Config.IsGreekPhone = false;
                                    Validation.isMatch($scope, 'Control.Form.Phone', /^[\+]?[\d]+$/g, {

                                    }).then(function (response) {
                                    }, function (error) { });
                                }
                            }, function (error) { });
                        } else {
                            if (checkoutConfig.phoneLocalizationEnabled) {
                                var $inputPhone = $('.form-row.phone.js-phone-localization input', $element);
                                Validation.isValidPhoneLocalized($scope, 'Control.Form.Phone', $inputPhone, $inputPhone.data('localized-validation'), {

                                }).then(function (response) {
                                }, function (error) {
                                    $scope.Control.IsOpen = true;
                                });
                            } else if ($scope.Control.Form.Country === 'GR' && checkoutConfig.greekPhoneValidation) {
                                $scope.Model.Data.Config.IsGreekPhone = true;
                                Validation.isMatch($scope, 'Control.Form.Phone', /^2[0-9]{9}$/g, {

                                }).then(function (response) {
                                }, function (error) {
                                    $scope.Control.IsOpen = true;
                                });
                            } else {
                                $scope.Model.Data.Config.IsGreekPhone = false;
                                Validation.isMatch($scope, 'Control.Form.Phone', /^[\+]?[\d]+$/g, {

                                }).then(function (response) {
                                }, function (error) { });
                            }
                        }
                    }
                }
            });

            validators.push({
                name: 'Control.Form.Mobile',
                fn: function() {
                    Validation.reset($scope, 'Control.Form.Mobile');
                    if ($scope.Model.Data.Config.IsMobileVisible) {
                        if ($scope.Model.Data.Config.IsMobileRequired) {
                            Validation.require($scope, 'Control.Form.Mobile').then(function (response) {
                                if (checkoutConfig.phoneLocalizationEnabled) {
                                    var $inputMobile = $('.form-row.mobile.js-phone-localization input', $element);
                                    Validation.isValidPhoneLocalized($scope, 'Control.Form.Mobile', $inputMobile, $inputMobile.data('localized-validation'), {

                                    }).then(function (response) {
                                    }, function (error) {
                                        $scope.Control.IsOpen = true;
                                    });
                                } else if ($scope.Control.Form.Country === 'GR' && checkoutConfig.greekMobileValidation) {
                                    $scope.Model.Data.Config.IsGreekMobile = true;
                                    Validation.isMatch($scope, 'Control.Form.Mobile', /^69[0-9]{8}$/g, {

                                    }).then(function (response) {
                                    }, function (error) {
                                        $scope.Control.IsOpen = true;
                                    });
                                } else {
                                    $scope.Model.Data.Config.IsGreekMobile = false;
                                    Validation.isMatch($scope, 'Control.Form.Mobile', /^[\+]?[\d]+$/g, {

                                    }).then(function (response) {
                                    }, function (error) { });
                                }
                            }, function (error) { });
                        } else {
                            if (checkoutConfig.phoneLocalizationEnabled) {
                                var $inputMobile = $('.form-row.mobile.js-phone-localization input', $element);
                                Validation.isValidPhoneLocalized($scope, 'Control.Form.Mobile', $inputMobile, $inputMobile.data('localized-validation'), {

                                }).then(function (response) {
                                }, function (error) {
                                    $scope.Control.IsOpen = true;
                                });
                            } else if ($scope.Control.Form.Country === 'GR' && checkoutConfig.greekMobileValidation) {
                                $scope.Model.Data.Config.IsGreekMobile = true;
                                Validation.isMatch($scope, 'Control.Form.Mobile', /^69[0-9]{8}$/g, {

                                }).then(function (response) {
                                }, function (error) {
                                    $scope.Control.IsOpen = true;
                                });
                            } else {
                                $scope.Model.Data.Config.IsGreekMobile = false;
                                Validation.isMatch($scope, 'Control.Form.Mobile', /^[\+]?[\d]+$/g, {

                                }).then(function (response) {
                                }, function (error) { });
                            }
                        }
                    }
                }
            });

            validators.push({
                name: 'Control.Form.Fax',
                fn: function () {
                    Validation.reset($scope, 'Control.Form.Fax');
                    if ($scope.Model.Data.Config.IsFaxVisible) {
                        if ($scope.Model.Data.Config.IsFaxRequired) {
                            Validation.require($scope, 'Control.Form.Fax').then(function (response) {
                                Validation.isMatch($scope, 'Control.Form.Fax', /^[\+]?[\d]+$/g, {

                                }).then(function (response) {
                                }, function (error) { });
                            }, function (error) { });
                        } else {
                            Validation.isMatch($scope, 'Control.Form.Fax', /^[\+]?[\d]+$/g, {

                            }).then(function (response) {
                            }, function (error) { });
                        }
                    }
                }
            });

            validators.push({
                name: 'Control.Form.PostCode',
                fn: function() {
                    Validation.reset($scope, 'Control.Form.PostCode');
                    Validation.require($scope, 'Control.Form.PostCode').then(function(response) {

                        var selectedCountry = _.first(_.filter($scope.Model.Data.ShippingCountries, function (x) { return x.Code === $scope.Control.Form.Country; }));

                        if ($element.data('areaautocomplete') && selectedCountry && selectedCountry.AreasCount > 1) {

                            $scope.Control.PostCodeFound = $scope.Control.Form.PostCode != "" && ($scope.Control.Form.Area != '' || ($scope.Control.Form.Area == '' && $('.PostalCodeLookUp option', $element).length > 1));

                        	if ($scope.Control.PostCodeFound) {
                                $scope.Control.Form.PostCodeInvalid = false;
                                $scope.Control.Form.PostCodeError = false;
                            } else {
                                $scope.Control.Form.PostCodeInvalid = true;
                                $scope.Control.Form.PostCodeError = true;
                            }
                        } else {
                            $scope.Control.PostCodeFound = false;
                            $scope.Control.Form.PostCodeInvalid = false;
                            $scope.Control.Form.PostCodeError = false;
                        }

                    }, function(error) {});
                }
            });

            validators.push({
                name: 'Control.Form.Address',
                fn: function() {
                    Validation.reset($scope, 'Control.Form.Address');
                    if ($scope.Model.Data.Config.IsAddressLine1Visible && $scope.Model.Data.Config.IsAddressLine1Required) {
                        Validation.require($scope, 'Control.Form.Address').then(function (response) { }, function (error) { });
                    }
                }
            });

            validators.push({
                name: 'Control.Form.Streetnumber',
                fn: function () {
                    Validation.reset($scope, 'Control.Form.Streetnumber');
                    if ($scope.Model.Data.Config.IsStreetnumberVisible && $scope.Model.Data.Config.IsStreetnumberRequired) {
                        Validation.require($scope, 'Control.Form.Streetnumber').then(function (response) { }, function (error) { });
                    }
                }
            });

            validators.push({
                name: 'Control.Form.Address2',
                fn: function () {
                    Validation.reset($scope, 'Control.Form.Address2');
                    if ($scope.Model.Data.Config.IsAddressLine2Visible && $scope.Model.Data.Config.IsAddressLine2Required) {
                        Validation.require($scope, 'Control.Form.Address2').then(function (response) { }, function (error) { });
                    }
                }
            });

            validators.push({
                name: 'Control.Form.Floor',
                fn: function () {
                    Validation.reset($scope, 'Control.Form.Floor');
                    if ($scope.Model.Data.Config.IsFloorVisible && $scope.Model.Data.Config.IsFloorRequired) {
                        Validation.require($scope, 'Control.Form.Floor').then(function (response) { }, function (error) { });
                    }
                }
            });

            validators.push({
                name: 'Control.Form.Apartment',
                fn: function () {
                    Validation.reset($scope, 'Control.Form.Apartment');
                    if ($scope.Model.Data.Config.IsApartmentVisible && $scope.Model.Data.Config.IsApartmentRequired) {
                        Validation.require($scope, 'Control.Form.Apartment').then(function (response) { }, function (error) { });
                    }
                }
            });

            validators.push({
                name: 'Control.Form.Block',
                fn: function () {
                    Validation.reset($scope, 'Control.Form.Block');
                    if ($scope.Model.Data.Config.IsBlockVisible && $scope.Model.Data.Config.IsBlockRequired) {
                        Validation.require($scope, 'Control.Form.Block').then(function (response) { }, function (error) { });
                    }
                }
            });

            validators.push({
                name: 'Control.Form.Entrance',
                fn: function () {
                    Validation.reset($scope, 'Control.Form.Entrance');
                    if ($scope.Model.Data.Config.IsEntranceVisible && $scope.Model.Data.Config.IsEntranceRequired) {
                        Validation.require($scope, 'Control.Form.Entrance').then(function (response) { }, function (error) { });
                    }
                }
            });

            validators.push({
                name: 'Control.Form.City',
                fn: function() {
                    Validation.reset($scope, 'Control.Form.City');
                    if ($scope.Model.Data.Config.IsCityVisible && $scope.Model.Data.Config.IsCityRequired) {
                        Validation.require($scope, 'Control.Form.City').then(function(response) {}, function(error) {});
                    }
                }
            });

            validators.push({
                name: 'Control.Form.Area',
                fn: function() {
                    Validation.reset($scope, 'Control.Form.Area');
                    if ($scope.Model.Data.Config.IsAreaVisible && $scope.Model.Data.Config.IsAreaRequired) {
                        Validation.require($scope, 'Control.Form.Area').then(function (response) { }, function (error) { });
                    }
                }
            });

            validators.push({
                name: 'Control.Form.Country',
                fn: function() {
                    Validation.reset($scope, 'Control.Form.Country');
                    Validation.require($scope, 'Control.Form.Country').then(function(response) {}, function(error) {});
                }
            });

            validators.push({
                name: 'Control.Form.Prefecture',
                fn: function () {
                    Validation.reset($scope, 'Control.Form.Prefecture');
                    if ($scope.Model.Data.Config.IsPrefectureVisible && $scope.Model.Data.Config.IsPrefectureRequired) {
                        Validation.require($scope, 'Control.Form.Prefecture').then(function (response) { }, function (error) { });
                    }
                }
            });

            validators.push({
                name: 'Control.Form.Bell',
                fn: function () {
                    Validation.reset($scope, 'Control.Form.Bell');
                    if ($scope.Model.Data.Config.IsBellVisible && $scope.Model.Data.Config.IsBellRequired) {
                        Validation.require($scope, 'Control.Form.Bell').then(function (response) { }, function (error) { });
                    }
                }
            });

            $element.get(0).validate = function(onComplete) {
                $scope.Control.IsValid = true;
                if ($scope.$parent.DeliveryPoint.Current.Code !== 'onSite') {
                    if (typeof (onComplete) === 'function') {
                        setTimeout(function() {
                            onComplete($scope.Control.IsValid);
                        }, 200);
                    }
                    return;
                }

                if (!$scope.Config.IsShippingEnabled) {
                    if (typeof (onComplete) === 'function') {
                        setTimeout(function() {
                            onComplete($scope.Control.IsValid);
                        }, 200);
                    }
                    return;
                }

                if ($scope.Control.IsOpen) {
                    _.first(_.filter(validators, function(x) { return x.name == 'Control.Form.Title' })).fn();
                    _.first(_.filter(validators, function(x) { return x.name == 'Control.Form.FirstName' })).fn();
                    _.first(_.filter(validators, function(x) { return x.name == 'Control.Form.LastName' })).fn();
                    _.first(_.filter(validators, function(x) { return x.name == 'Control.Form.Email' })).fn();
                    _.first(_.filter(validators, function(x) { return x.name == 'Control.Form.EmailConfirmation' })).fn();
                    _.first(_.filter(validators, function(x) { return x.name == 'Control.Form.Phone' })).fn();
                    _.first(_.filter(validators, function(x) { return x.name == 'Control.Form.Mobile' })).fn();
                    _.first(_.filter(validators, function(x) { return x.name == 'Control.Form.Fax' })).fn();
                    _.first(_.filter(validators, function(x) { return x.name == 'Control.Form.PostCode' })).fn();
                    _.first(_.filter(validators, function(x) { return x.name == 'Control.Form.Address' })).fn();
                    _.first(_.filter(validators, function(x) { return x.name == 'Control.Form.Streetnumber' })).fn();
                    _.first(_.filter(validators, function (x) { return x.name == 'Control.Form.Address2' })).fn();
                    _.first(_.filter(validators, function (x) { return x.name == 'Control.Form.Floor' })).fn();
                    _.first(_.filter(validators, function (x) { return x.name == 'Control.Form.Apartment' })).fn();
                    _.first(_.filter(validators, function (x) { return x.name == 'Control.Form.Block' })).fn();
                    _.first(_.filter(validators, function (x) { return x.name == 'Control.Form.Entrance' })).fn();
                    _.first(_.filter(validators, function(x) { return x.name == 'Control.Form.City' })).fn();
                    _.first(_.filter(validators, function(x) { return x.name == 'Control.Form.Area' })).fn();
                    _.first(_.filter(validators, function(x) { return x.name == 'Control.Form.Country' })).fn();
                    _.first(_.filter(validators, function(x) { return x.name == 'Control.Form.Prefecture' })).fn();
                    _.first(_.filter(validators, function(x) { return x.name == 'Control.Form.Bell' })).fn();

                    if (typeof (onComplete) === 'function') {
                        setTimeout(function() {
                            onComplete($scope.Control.IsValid);
                        }, 200);
                    }
                } else if ($scope.Control.Selected == 0) {
                    Validation.require($scope, 'Control.Selected', {
                        defaultValue: '0'
                    }).then(function(response) {}, function(error) {});

                    if (typeof (onComplete) === 'function') {
                        setTimeout(function() {
                            onComplete($scope.Control.IsValid);
                        }, 200);
                    }
                } else {
                    var selectedAddress = _.first(_.filter($scope.Model.Data.Addresses, function (x) { return x.Id == $scope.Control.Selected; }));

                    angular.extend($scope.Control.Form, selectedAddress);

                    _.first(_.filter(validators, function (x) { return x.name == 'Control.Form.Title' })).fn();
                    _.first(_.filter(validators, function (x) { return x.name == 'Control.Form.FirstName' })).fn();
                    _.first(_.filter(validators, function (x) { return x.name == 'Control.Form.LastName' })).fn();
                    _.first(_.filter(validators, function (x) { return x.name == 'Control.Form.Email' })).fn();
                    _.first(_.filter(validators, function (x) { return x.name == 'Control.Form.EmailConfirmation' })).fn();
                    _.first(_.filter(validators, function (x) { return x.name == 'Control.Form.Phone' })).fn();
                    _.first(_.filter(validators, function (x) { return x.name == 'Control.Form.Mobile' })).fn();
                    _.first(_.filter(validators, function (x) { return x.name == 'Control.Form.Fax' })).fn();
                    _.first(_.filter(validators, function (x) { return x.name == 'Control.Form.PostCode' })).fn();
                    _.first(_.filter(validators, function (x) { return x.name == 'Control.Form.Address' })).fn();
                    _.first(_.filter(validators, function (x) { return x.name == 'Control.Form.Streetnumber' })).fn();
                    _.first(_.filter(validators, function (x) { return x.name == 'Control.Form.Address2' })).fn();
                    _.first(_.filter(validators, function (x) { return x.name == 'Control.Form.Floor' })).fn();
                    _.first(_.filter(validators, function (x) { return x.name == 'Control.Form.Apartment' })).fn();
                    _.first(_.filter(validators, function (x) { return x.name == 'Control.Form.Block' })).fn();
                    _.first(_.filter(validators, function (x) { return x.name == 'Control.Form.Entrance' })).fn();
                    _.first(_.filter(validators, function (x) { return x.name == 'Control.Form.City' })).fn();
                    _.first(_.filter(validators, function (x) { return x.name == 'Control.Form.Area' })).fn();
                    _.first(_.filter(validators, function (x) { return x.name == 'Control.Form.Country' })).fn();
                    _.first(_.filter(validators, function (x) { return x.name == 'Control.Form.Prefecture' })).fn();
                    _.first(_.filter(validators, function (x) { return x.name == 'Control.Form.Bell' })).fn();

                    if ($scope.Control.IsValid == false) {
                        Validation.reset($scope, 'Control.Form.PostCode');
                        setTimeout(function () {
                            $scope.Control.IsOpen = true;
                        }, 500);
                    }

                    if (typeof (onComplete) === 'function') {
                        setTimeout(function() {
                            onComplete($scope.Control.IsValid);
                        }, 200);
                    }
                }

                initiallyValidated = true;
            };

            $element.get(0).set = function() {
                var deferred = $q.defer();

                var address = $scope.Control.IsOpen || !$scope.Order.Current.IsLoggedIn ? $scope.Control.Form : $scope.Control.Text;
                ControlService.invokeCheckout($scope, $element, 'SetShippingAddress', address).then(function (setResponse) {
                    $scope.setControlValue(controlName, address);
                    deferred.resolve(true);
                    $scope.Control.Loading = false;
                }, function(error) {
                    deferred.reject(error);
                    $scope.Control.Loading = false;
                });

                return deferred;
            };

            $element.get(0).focus = function() {
                if (!$scope.Control.IsValid)
                    $('.x-invalid:first *[ng-model]', $element).focus();
                else
                    $('*[ng-model]:first', $element).focus();
            };

            $scope.preventPaste = function(e) {
                e.preventDefault();
                return false;
            };

            var isAddressOk = function (addr) {
                var result = true;

                if (
                    ($scope.Model.Data.Config.IsTitleVisible && $scope.Model.Data.Config.IsTitleRequired && addr.Title === '') ||
                    ($scope.Model.Data.Config.IsFirstNameVisible && $scope.Model.Data.Config.IsFirstNameRequired && addr.FirstName === '') ||
                    ($scope.Model.Data.Config.IsLastNameVisible && $scope.Model.Data.Config.IsLastNameRequired && addr.LastName === '') ||
                    ($scope.Model.Data.Config.IsEmailVisible && $scope.Model.Data.Config.IsEmailRequired && addr.Email === '') ||
                    ($scope.Model.Data.Config.IsPhoneVisible && $scope.Model.Data.Config.IsPhoneRequired && addr.Phone === '') ||
                    ($scope.Model.Data.Config.IsMobileVisible && $scope.Model.Data.Config.IsMobileRequired && addr.Mobile === '') ||
                    ($scope.Model.Data.Config.IsFaxVisible && $scope.Model.Data.Config.IsFaxRequired && addr.Fax === '') ||
                    ($scope.Model.Data.Config.IsAddressLine2Visible && $scope.Model.Data.Config.IsAddressLine2Required && addr.Address2 === '') ||
                    ($scope.Model.Data.Config.IsStreetnumberVisible && $scope.Model.Data.Config.IsStreetnumberRequired && addr.Streetnumber === '') ||
                    ($scope.Model.Data.Config.IsFloorVisible && $scope.Model.Data.Config.IsFloorRequired && addr.Floor === '') ||
                    ($scope.Model.Data.Config.IsApartmentVisible && $scope.Model.Data.Config.IsApartmentRequired && addr.Apartment === '') ||
                    ($scope.Model.Data.Config.IsBlockVisible && $scope.Model.Data.Config.IsBlockRequired && addr.Block === '') ||
                    ($scope.Model.Data.Config.IsEntranceVisible && $scope.Model.Data.Config.IsEntranceRequired && addr.Entrance === '') ||
                    ($scope.Model.Data.Config.IsCityVisible && $scope.Model.Data.Config.IsCityRequired && addr.City === '') ||
                    ($scope.Model.Data.Config.IsBellVisible && $scope.Model.Data.Config.IsBellRequired && addr.Bell === '') ||
                    ($scope.Model.Data.Config.IsPrefectureVisible && $scope.Model.Data.Config.IsPrefectureRequired && addr.Prefecture === '')
                )
                    result = false;

                if (addr.PostCode === '' || addr.Address === '' || addr.Area === '' || addr.Country === '')
                    result = false;

                if (!_.first(_.filter($scope.Model.Data.ShippingCountries, function (x) { return x.Code === addr.Country; })))
                    result = false;

                return result;
            };

            ControlService.getCheckoutData("GetShippingAddressData", $scope, $element).then(function (response) {
                $scope.Model = {};
                $scope.Control.Text = {};

                angular.extend($scope.Model, response);
                var open = false;

                var selectedAddress = _.first(_.filter($scope.Model.Data.Addresses, function(x) { return x.IsDefault; }));
                if (selectedAddress === undefined)
                    selectedAddress = _.first($scope.Model.Data.Addresses);

                if ($scope['Order'] && $scope['Order'].Current && $scope['Order'].Current.Shipping) {
                    if ($scope['Order'].Current.Shipping.Id !== 0) {
                        selectedAddress = _.first(_.filter($scope.Model.Data.Addresses, function(x) { return x.Id == $scope['Order'].Current.Shipping.Id; }));
                    } else {
                        if (checkoutOverrides && checkoutOverrides.Shipping && typeof checkoutOverrides.Shipping.CheckOnGetData === 'function') {
                            var result = checkoutOverrides.Shipping.CheckOnGetData($scope['Order'].Current);

                            if (typeof result.selectedAddress !== 'undefined')
                                selectedAddress = result.selectedAddress;

                            if (typeof result.open !== 'undefined')
                                open = result.open;

                        } else {
                            selectedAddress = $scope['Order'].Current.Shipping;
                            open = true;
                        }
                    }
                }

                if (selectedAddress) {

                    var selectedTitle = _.first(_.filter($scope.Model.Data.Titles, function (x) { return x.Name === selectedAddress.Title; }));
                    if (!selectedTitle)
                        selectedAddress.Title = '';

                    if (!isAddressOk(selectedAddress))
                        open = true;

                    $scope.Control.Selected = selectedAddress.Id;
                    angular.extend($scope.Control.Form, selectedAddress);
                    if (open) {

                        setFormCountry();
                        $scope.Control.IsOpen = true;
                    } else {
                        angular.extend($scope.Control.Text, selectedAddress);
                        setTextCountry();
                    }
                    $scope.setControlValue(controlName, selectedAddress);
                }

                if ($element.data('areaautocomplete')) {
                    bindAreaAutoComplete();
                }

                savedData.setData($scope.Control.Form);

                $scope.Control.Loading = false;
            }, function (error) {
                $scope.Control.Loading = false;
                throw error;
            });

            $scope.Control.updateAddresses = function (selected) {
                $scope.ShippingAddresses.Items = [];
                if (!selected || $scope.Model.Data.Addresses.length == 0) { return; }
                $scope.ShippingAddresses.Selected = false;
                var ids = [];
                for (var i = 0, j = 0; i < $scope.Model.Data.Addresses.length; i++) {
                    $scope.ShippingAddresses.Items.push($scope.Model.Data.Addresses[i]);

                    if (selected == $scope.ShippingAddresses.Items[i].Id) {
                        $scope.ShippingAddresses.Selected = true;
                        $scope.ShippingAddresses.Items[i].Selected = true;
                    } else {
                        $scope.ShippingAddresses.Items[i].Selected = false;
                    }
                    j++;
                }
                $scope.updateReviewBoxAddresses();
            };

            angular.element($element.get(0)).ready(function () {
                var selectedAddress = $scope.Control.Form;
                var selectedCountry = _.first(_.filter($scope.Model.Data.ShippingCountries, function (c) { return selectedAddress.Country == c.Code; }));
                if (selectedAddress !== undefined && selectedAddress.PostCode != "" && selectedAddress.Area == "" && (selectedCountry ? selectedCountry.AreasCount > 1 : false)) {
                    $('input[type="text"][ng-model="Control.Form.Area"]', $element).val("");
                    $('input',$postCodeField).trigger('keyup');
                }
                $scope.Control.getPrefectures();
                $scope.Control.getCities();
                $scope.Control.getAreas();
                $scope.Control.updateAddresses($scope.Control.Selected);

                if (checkoutOverrides && checkoutOverrides.Generic && typeof checkoutOverrides.Generic.initPhoneLocalization === 'function') {
                    if (checkoutConfig.phoneLocalizationEnabled) checkoutOverrides.Generic.initPhoneLocalization($element.get(0), $scope);
                }               
            });

            $('input[type="text"][ng-model="Control.Form.Area"]', $element).keypress(function(e) {
                var selectedCountry = _.first(_.filter($scope.Model.Data.ShippingCountries, function(x) { return x.Code === $scope.Control.Form.Country; }));
                if ($element.data('areaautocomplete') && selectedCountry.AreasCount > 1) {
                    e.preventDefault();
                }
            });
        });
})();